/**
 * Génère un code d'entité (client, fournisseur, article, code-barre)
 * à partir d'un préfixe, d'une valeur numérique et d'une longueur de padding.
 *
 * Exemples :
 *   generateEntityCode('CLI', 1, 4)  → "CLI0001"
 *   generateEntityCode('FRN', 42, 4) → "FRN0042"
 *   generateEntityCode('', 1, 8)     → "00000001"   (code-barre sans préfixe)
 *
 * Note : l'incrémentation atomique est gérée côté base de données
 * (RPC consume_entity_code). Cette fonction ne fait que formater.
 */
export function generateEntityCode(
  prefix: string,
  value: number,
  padding = 4,
): string {
  const safePadding = padding > 0 ? padding : 1;
  const padded = String(Math.max(0, Math.trunc(value))).padStart(safePadding, '0');
  return `${prefix}${padded}`;
}

/**
 * Avance un code formaté de `by` positions : "ART0042" → "ART0043",
 * "00000099" → "00000100". Sert à AFFICHER les codes que N créations
 * consécutives obtiendraient — la valeur réelle reste attribuée par le
 * compteur atomique au moment de la création. Un code sans suffixe
 * numérique, ou un `by` nul, est rendu tel quel.
 */
export function incrementEntityCode(code: string, by: number): string {
  const match = /^(.*?)(\d+)$/.exec(code);
  if (!match || !Number.isFinite(by) || by <= 0) return code;
  const head = match[1] ?? '';
  const digits = match[2] ?? '';
  // BigInt : un code-barre EAN dépasse la précision entière d'un number.
  const next = (BigInt(digits) + BigInt(Math.trunc(by))).toString();
  return `${head}${next.padStart(digits.length, '0')}`;
}
